module.exports = __webpack_public_path__ + "img/swiper_01.6b69c664.jpg";